<template lang="html">

  <section class="list-view row-center">
    <div class="contenedor-listado" :style="styles.backgroundWhite" :showEncuesta="false" :hasFicha="false"
      v-if="!isFicha">

      <div class="scroll-container">

        <section class="contenedor-tabla" :style="styles.colorBasic">

          <div class="contenedor-opciones row-between">

            <h2 class="ficha-title" :style="styles.colorBasic">Listado de ofertas</h2>

            <div class="row-end">

            </div>

          </div>
          <template v-if="loading">
            <div class="loader" id="loader"></div>
            <p class="loader-text">CARGANDO...</p>
          </template>
          <div class="scroll-table" v-else>
            <multiselect v-model="titulacionesSeleccionadas" :options="dataTitulaciones" :multiple="true"
              :close-on-select="false" :clear-on-select="false" :limit="5" :limit-text="limitText"
              :preserve-search="true" label="descripcion" track-by="descripcion" :preselect-first="false"
              :closeOnSelect="true" @select="back" @remove="back" placeholder="Seleccionar titulaciones"
              selectedLabel="Seleccionado" selectLabel="Presiona enter para seleccionar"
              deselectLabel="Presiona enter para deseleccionar"></multiselect>
            <h4>
              {{ "Mostrando " + ofertasFiltradas.length + (ofertasFiltradas.length == 1 ? " oferta" : " ofertas") }}
            </h4>

            <div class="contenedor-tabla" :type="$route.name" v-if="!!ofertasFiltradas">
              <template v-if="ofertasFiltradas && ofertasFiltradas.length != 0">

                <v-client-table :data="ofertasFiltradas" @row-click='open' :columns="columns" :options="options">
                  <span class="checkbox-cell row-start" slot="checkbox" slot-scope="{ row }">
                  </span>

                  <span class="action-cell row-start" slot="actions" slot-scope="{ row }">
                    <router-link :to="linkBack + row.idPractica" class="to-ficha">
                      <next></next>
                    </router-link>
                  </span>
                </v-client-table>
              </template>

              <template v-else>
                NO HAY DATOS
              </template>

            </div>

          </div>

        </section>

      </div>
    </div>

    <div class="contenedor-ficha" :style="ownstyle.ficha" v-if="showFicha" :full="fichaView.full" :showEncuesta="false">

      <div class="settings row-end" :style="styles.colorSoftBasic" v-if="!isFicha">
        <a @click="fichaView.full = !fichaView.full" class="icon-ampliar">
          <icon-ampliar v-if="!fichaView.full"></icon-ampliar>
          <icon-minificar v-if="fichaView.full"></icon-minificar>
        </a>
        <router-link :to="'/ofertas-practicas/'" title="Cerrar ficha">✕</router-link>
      </div>

      <div class="scroll-container">
        <contenedor-ficha v-if="$route.name != 'aprobaciones'" :full="fichaView.full"
          @cerrarFicha="back"></contenedor-ficha>
      </div>

    </div>

  </section>

</template>

<script lang="js">

import { ClientTable, Event } from 'vue-tables-2';

import Vue from 'vue';

Vue.use(ClientTable);

import { mapActions, mapGetters } from 'vuex';

import router from '@/router';

import ampliar from '@/components/parts/icons/ampliar';
import minificar from '@/components/parts/icons/minificar';
import contenedorFicha from '@/components/views/contenedor-ficha'

export default {
  name: 'list-view-ofertas-tutor',
  data() {
    return {
      fichaView: {
        full: false,
        view: false,
        id: ''
      },
      titulacionesSeleccionadas: [],
      // columns: ["mailitem_id", "destinatarios", "destinatariosCopia", "destinatariosCopiaOculta", "asunto", "fechaAlta", "fechaSolicitudEnvio", "enviadoOK"],
      columns: ["idOferta", "puestoTrabajo", "fechaAlta", "fechaCaducidad", "numPuestosDisponibles", "estado", "gestor", "empresa"],
      options: {
        skin: 'table',
        highlightMatches: true,
        headings: {
          idOferta: "Id oferta",
          puestoTrabajo: "Nombre Oferta",
          fechaAlta: "Fecha Alta",
          fechaCaducidad: "Fecha Caducidad",
          numPuestosDisponibles: "Nº Plazas",
          estado: "Estado",
          gestor: "Gestor",
          empresa: "Empresa"
        },
        filterable: false,
        texts: {
          filter: "Buscar:",
          filterBy: 'Filtrar por {column}',
          count: '',
          records: 'Resultados',
          limit: "Por Página: ",
          page: "Págína:",
          noResults: "No se han encontrado resultados",
          filterPlaceholder: "Escribe para buscar",
        },
        customSorting: {
          fechaAlta: function (ascending) {
            return function (a, b) {

              var dateObjectA, dateObjectB;

              if (a.fechaAlta != null && a.fechaAlta != "") {
                var datePartsA = a.fechaAlta.split("/");
                dateObjectA = new Date(+datePartsA[2], datePartsA[1] - 1, +datePartsA[0]);
              }

              if (b.fechaAlta != null && b.fechaAlta != "") {
                var datePartsB = b.fechaAlta.split("/");
                dateObjectB = new Date(+datePartsB[2], datePartsB[1] - 1, +datePartsB[0]);
              }

              if (ascending)
                return dateObjectA >= dateObjectB ? 1 : -1;

              return dateObjectA <= dateObjectB ? 1 : -1;
            }
          },
          fechaCaducidad: function (ascending) {
            return function (a, b) {

              var dateObjectA, dateObjectB;

              if (a.fechaCaducidad != null && a.fechaCaducidad != "") {
                var datePartsA = a.fechaCaducidad.split("/");
                dateObjectA = new Date(+datePartsA[2], datePartsA[1] - 1, +datePartsA[0]);
              }

              if (b.fechaCaducidad != null && b.fechaCaducidad != "") {
                var datePartsB = b.fechaCaducidad.split("/");
                dateObjectB = new Date(+datePartsB[2], datePartsB[1] - 1, +datePartsB[0]);
              }

              if (ascending)
                return dateObjectA >= dateObjectB ? 1 : -1;

              return dateObjectA <= dateObjectB ? 1 : -1;
            }
          }
        },
        dateFormat: 'DD-MM-YY',
        perPage: 30,
        resizableColumns: true,
        perPageValues: [10, 20, 30, 50],
        columnsClasses: {},
        sortIcon: {
          is: 'glyphicon-sort',
          base: 'glyphicon',
          up: 'fa fa-angle-up',
          down: 'fa fa-angle-down'
        },
        rowClassCallback(row, $route) {
          let lastParam = window.location.pathname.split("/").pop();
          return (row.idPractica == lastParam) ? 'selected' : '';
        }
      }
    }
  },
  mounted() {
    this.fichaView.full = (this.$route.name == 'ficha');
    this.setColumnas();
  },
  methods: {
    ...mapActions(['setMenu']),
    setColumnas() {

    },
    back: function () {
      router.push('/ofertas-practicas');
    },
    open: function ({ row }) {
      if (event.target.tagName == "TD") {
        router.push(`/ofertas-practicas/${row.idOferta}`);
      }
    },
    limitText(count) {
      if (count == 1) return `y otra titulación`
      else return `y otras ${count} titulaciones`
    },
  },
  components: {
    'icon-ampliar': ampliar,
    'icon-minificar': minificar,
    'contenedor-ficha': contenedorFicha,

  },
  computed: {
    ...mapGetters({
      styles: 'getStyles',
      colors: 'basicColors',
      dataTitulaciones: "getTitulacionesCoordinacionPracticas",
      dataOfertas: "getOfertasTitulacionesCoordinacionPracticas",
      loading: 'getLoading'
    }),
    ownstyle: function () {
      return {
        ficha: {
          'border-left': `10px solid ${this.colors.backgroundBody}`,
          background: this.colors.white
        },
        vistaEncuesta: {
          'border-left': `10px solid ${this.colors.backgroundBody}`,
          background: this.colors.white
        }
      }
    },
    ofertasFiltradas: function () {
      if (this.titulacionesSeleccionadas == null || this.titulacionesSeleccionadas.length == 0) {
        return this.dataOfertas;
      } else {
        return this.dataOfertas.filter(oferta => oferta.idsTitulacion.some(id => (this.titulacionesSeleccionadas.map((obj) => obj.idTitulacion)).indexOf(id) !== -1));;
      }
    },
    isFicha: function () {
      return (this.$route.name == 'ficha');
    },
    showFicha: function () {
      return (Number(this.$route.params.status) > 0 | !!this.$route.params.id) ? true : false;
    },
  },
  watch: {

  }
}
</script>

<style lang="scss">
.list-view {
  width: 100%;
  height: 100%;
  -webkit-flex-wrap: nowrap;
  -moz-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  -o-flex-wrap: nowrap;
  flex-wrap: nowrap;
  max-height: 100%;
  position: relative;

}

.contenedor-listado {
  width: 100% !important;
  height: 100% !important;
  display: inline-block !important;
  overflow: hidden !important;
  padding: 20px !important;
}

.contenedor-ficha {
  width: 100%;
  height: 100%;
  display: inline-block;
  max-width: 600px;
  min-width: 500px;
  overflow: hidden;
  padding: 10px;
  position: relative;

  &[full="true"] {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 7;
    max-width: 100%;
    border-left: none !important;
  }


}

.scroll-container {
  width: 100%;
  height: 100%;
  min-height: 100%;
  display: inline-block;
  overflow: hidden;
}


.contenedor-ficha .scroll-container {
  // overflow: hidden;
}

.settings {
  position: absolute;
  right: 5px;
  top: 0;
  height: 30px;
  width: 100px;
  z-index: 5;
}

.settings a {
  width: 25px;
  height: 30px;
  display: inline-block;
  line-height: 30px;
}

.contenedor-vista-encuesta {
  width: 100%;
  height: 100%;
  max-width: 600px;
  min-width: 500px;
  overflow: hidden;
  position: relative;
  flex-grow: 2;

  &[full="true"] {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 5;
    max-width: 100%;
    border-left: none !important;
  }
}

.tabla-responsive {
  display: none;
}

@media screen and (max-height: 900) {
  .contenedor-listado {
    .tabla-responsive {
      display: inline-block;
      width: 100%;
    }

    .tabla-pc {
      display: none;
    }
  }
}

@media screen and (max-width: 1400px) {
  .contenedor-listado {
    &[showEncuesta=true] {
      display: none;
    }
  }

  .contenedor-ficha {
    max-width: 100%;

    &[showEncuesta=true] {
      border-left: none !important;
    }
  }

  .contenedor-vista-encuesta {
    max-width: 100%;
  }

}

@media screen and (max-width: 1200px) {
  .contenedor-listado[hasFicha="true"] {
    .tabla-responsive {
      display: inline-block;
      width: 100%;
    }

    .tabla-pc {
      display: none;
    }
  }
}

@media screen and (max-width: 1023px) {
  .contenedor-listado {
    &[hasFicha=true] {
      display: none;
    }
  }

  .contenedor-listado {
    .tabla-responsive {
      display: inline-block;
      width: 100%;
    }

    .tabla-pc {
      display: none;
    }
  }


  .contenedor-ficha[showEncuesta="true"] {
    display: none;
  }

  .settings .icon-ampliar {
    display: none;
  }

  .contenedor-ficha {
    border-left: none !important;
    min-width: 100%;
  }

  .contenedor-vista-encuesta {
    min-width: 0;
    border-left: none !important;
  }

}

@media screen and (max-width: 600px) {
  .contenedor-listado {
    padding: 10px!important;
  }
}

.ficha-title {
  margin-top: 0;
  margin-bottom: 0;
  width: auto;
}

.toggle-todo {
  position: absolute;
  left: 10px;
  top: 47px;
  width: 15px;
  height: 15px;
  line-height: 15px;
  background: #d8d8d8;
  font-size: 12px;
  color: #4a4a4a;
}

.contenedor-tabla {
  width: 100%;
  min-height: 100%;
  display: inline-block;
}

.contenedor-opciones {
  width: 100%;
  // padding-bottom: 20px;
  position: relative;
}

.option-table {
  text-transform: uppercase;
  font-size: 9px;
  text-align: center;
  padding: 0 10px;
  position: relative;
}

.column {
  width: 30px;
  height: 30px;
  position: relative;
  margin-bottom: 10px;

  svg {
    width: 40px;
  }
}

.to-ficha {
  width: 10px;
  height: 20px;
  display: inline-block;
  font-size: 0;

  svg {
    width: 10px;
    height: 20px;
  }
}


.checkbox-cell {
  min-width: 55px;
}

.VueTables__table {
  width: 100% !important;
}

h4 {
  text-align: left;
  margin: 12px 3px 2px 3px;
}

.multiselect {
  margin: 10px 0;
}

.table-responsive {
  width: 100%;
  display: inline-block;
  overflow: scroll;
  max-height: calc(100vh - 315px);
}

.multiselect__tag,
.multiselect__option--highlight {
  background: #003865;
}

.multiselect__tags {
  white-space: nowrap;
  overflow: hidden;
  width: calc(100% - 15px);
}

.multiselect__tag-icon:after {
  color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/views/list-view-ofertas-tutor.vue